/** @prettier */
import PropTypes from 'prop-types';
import React from 'react';

import { PRODUCTS } from '@xanadu/ui-shared/constants';

import IconCasino from './icons/casino.svg';
import IconExchange from './icons/exchange.svg';
import IconLiveCasino from './icons/live-casino.svg';
import IconPredictions from './icons/predictions.svg';
import IconVirtuals from './icons/virtuals.svg';
import IconZero from './icons/zero.svg';

const ICONS_BY_PRODUCT = {
  [PRODUCTS.exchange]: IconExchange,
  [PRODUCTS.mbzero]: IconZero,
  [PRODUCTS.casino]: IconCasino,
  [PRODUCTS.liveCasino]: IconLiveCasino,
  [PRODUCTS.virtuals]: IconVirtuals,
  [PRODUCTS.predictions]: IconPredictions,
};

const ProductIcon = ({ product, className }) => {
  const Icon = ICONS_BY_PRODUCT[product] || ICONS_BY_PRODUCT[PRODUCTS.exchange];

  return <Icon className={className} />;
};

ProductIcon.propTypes = {
  product: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ProductIcon;
